export default __webpack_public_path__ + "static/media/tms.0f74cfd1.ico";